import DistributeHeight from '../Utilities/DistributeHeight'

const distributeHeight = new DistributeHeight

export class FunctionGuide {
  constructor () {
    this.functionGuide = $('[data-init="function-guide"]')
    this.scrollOffset = false
    this.activePanelIndex = 0
    this.maxPanelIndex = 5
    this.panelOpened = false
  }

  historyPopstate() {
    if (window.location.hash && $('.function-sectors').length > 0) {
      let id = window.location.hash.substr(1);
      this.activePanelIndex = $('[data-id="' + id + '"]').index() / 2
      this.expandPanel()
    }
  }

  initEventHandlers () {
    $('[data-toggle="function-panel"]').on('click', $.proxy(this.togglePanelClickHandler, this))
    $('[data-role="function-guide-navigation"]').on('click', $.proxy(this.functionNavigationHandler, this))
    $('[data-role="sector-navigation"]').on('click', $.proxy(this.sectorNavigationHandler, this))
  }

  setHeight () {
    if ($(window).width() < 768) {
      this.functionGuide.css('min-height', 'auto')
      this.functionGuide.children('div').css('min-height', 'auto')
      return
    }

    let height = $(window).height() - $('#footer').height() - $('.navbar').height()
    this.functionGuide.css('min-height', height)
    this.functionGuide.children('div').css('min-height', height)
    distributeHeight.setHeights()
  }

  togglePanelClickHandler (e) {
    e.preventDefault()
    let $this = $(e.currentTarget)
    this.activePanelIndex = $this.parents('.function-sector').index() / 2
    this.expandPanel()
  }

  expandPanel () {
    let $sectorPanel = $(`.function-sector:eq(${this.activePanelIndex})`)
    let $panel = $sectorPanel.next('.function-sector-panel')
    let itemCount = 3
    let offset = 0

    if ($(window).width() < 768) {
      $panel.slideToggle()
      distributeHeight.setHeights()
    }

    if ($panel.hasClass('active')) {
      $sectorPanel.removeClass('active')
      $panel.removeClass('active')
      history.pushState(null, null, '#');

      if (this.scrollOffset && $(window).width() < 992) {
        offset = - $(window).width() / itemCount * 3
      }

      // Reset the position of all items
      if (this.scrollOffset && $(window).width() < 992) {
        this.activePanelIndex = 3
      } else {
        this.activePanelIndex = 0
      }

      this.panelOpened = false
      this.setPanelOffset(offset)
      this.setTitles()
      return
    }
    // Close all panels
    $('.function-sector').removeClass('active')
    $('.function-sector-panel').removeClass('active')

    // Activate the selected panel
    $sectorPanel.addClass('active')
    $panel.addClass('active')
    history.pushState(null, null, '#' + $sectorPanel.data('id'));

    this.panelOpened = true

    if ($(window).width() >= 768) {
      this.movePanels()
      this.setTitles()
    }
  }

  closeAllPanels () {
    $('.function-sector').removeClass('active')
    $('.function-sector-panel').removeClass('active')
  }

  closeAllPanelsOnMobile () {
    if ($(window).width() < 768) {
      this.panelOpened = false
      $('.function-sector-panel').css('display', 'none')
      $('.function-sector').removeClass('active')
      $('.function-sector-panel').removeClass('active')
    }
    else {
      $('.function-sector-panel').css('display', 'block')
    }
  }

  movePanels () {
    let itemCount = 6
    let index = this.activePanelIndex

    if ($(window).width() < 992) {
      itemCount = 3

      if (this.scrollOffset && !this.panelOpened) {
        index = 3
      }
    }

    if ($(window).width() >= 992 && !this.panelOpened) {
      index = 0
    }

    let offset = - $(window).width() / itemCount * index
    this.setPanelOffset(offset)
  }

  setPanelOffset(offset) {
    offset = offset + 'px'

    if ($(window).width() < 768) {
      offset = 0
    }

    this.functionGuide.children().css({
      'transform': `translateX(${offset})`
    })
  }

  functionNavigationHandler (e) {
    e.preventDefault()
    $('.function-guide-pager-item').removeClass('active')
    $(e.currentTarget).addClass('active')


    let direction = $(e.currentTarget).data('direction')
    let itemCount = 3
    let offset = ''

    if ((direction === 'previous' && !this.scrollOffset) || (direction === 'next' && this.scrollOffset)) {
      return
    }

    if (direction === 'previous' && this.scrollOffset) {
      this.scrollOffset = false
      offset = 0
    } else if (direction === 'next' && !this.scrollOffset) {
      this.scrollOffset = true
      offset = - $(window).width() / itemCount * 3
    }

    this.closeAllPanels()
    this.setPanelOffset(offset)
  }

  sectorNavigationHandler (e) {
    e.preventDefault()
    let $this = $(e.currentTarget)
    let direction = $this.data('direction')

    if (direction === 'previous') {

      if (this.activePanelIndex === 0) {
        this.activePanelIndex = this.maxPanelIndex
      } else {
        this.activePanelIndex --
      }
    } else {

      if (this.activePanelIndex === this.maxPanelIndex) {
        this.activePanelIndex = 0
      } else {
        this.activePanelIndex ++
      }
    }

    this.expandPanel()
  }

  setTitles () {
    let previousIndex = this.activePanelIndex - 1
    let nextIndex = this.activePanelIndex + 1

    if (previousIndex === -1) {
      previousIndex = this.maxPanelIndex
    }

    if (nextIndex > this.maxPanelIndex) {
      nextIndex = 0
    }

    let previousTitle = $(`.function-sector:eq(${previousIndex})`).find('.sector-title').text()
    let currentTitle = $(`.function-sector:eq(${this.activePanelIndex})`).find('.sector-title').text()
    let nextTitle = $(`.function-sector:eq(${nextIndex})`).find('.sector-title').text()

    if (!this.panelOpened) {
      currentTitle = ''
    }

    $('.current-sector').text(currentTitle)

    $('.sector-pager').find('.previous-sector .pager-label').text(previousTitle)
    $('.sector-pager').find('.next-sector .pager-label').text(nextTitle)
  }
}



// WEBPACK FOOTER //
// ./src/Frontend/Themes/Custom/src/Js/Theme/FunctionGuide.js